import {
  getCountriesAction,
  getArtistsNumberAction,
  getPerformancesNumberAction,
  tokenLoginAction,
  getRegionsAction,
  setIsLoggedInAction,
  remoteLogoutAction,
  tokenLoginLoadingnAction,
  getUserConstants,
} from './actions';
import { logoutAction } from '../containers/App/actions';
import { defaultListParams, listReducer } from '../utils/crudUtils';

export const initialAppState = {
  token: null,
  isLoggedIn: false,
  countries: [],
  countriesLoading: false,
  regions: defaultListParams,
  error: false,
  isLoggedOut: true,
  isLoginLoading: false,
  userConstants: [],
};

function appReducer(state = initialAppState, { type, payload }) {
  switch (type) {
    case getRegionsAction.TRIGGER:
    case getRegionsAction.SUCCESS:
    case getRegionsAction.FAILURE:
      return listReducer(state, type, payload, 'regions');

    case getCountriesAction.TRIGGER:
      return { ...state, countries: [], countriesLoading: true };
    case getCountriesAction.SUCCESS:
      return { ...state, countries: payload, countriesLoading: false };
    case getCountriesAction.FAILURE:
      return { ...state, countriesLoading: false, error: payload };

    case getArtistsNumberAction.SUCCESS:
      return { ...state, artistsNumber: payload };
    case getPerformancesNumberAction.SUCCESS:
      return { ...state, performancesNumber: payload };
    case tokenLoginAction.TRIGGER:
      return { ...state };
    case tokenLoginAction.SUCCESS:
      return { ...state, isLoggedOut: false, isLoginLoading: false };
    case tokenLoginAction.FAILURE:
      return { ...state, error: payload, isLoginLoading: false };
    case tokenLoginLoadingnAction.TRIGGER:
      return { ...state, isLoginLoading: payload };
    case logoutAction.TRIGGER:
      return { ...state, token: undefined };

    case setIsLoggedInAction.TRIGGER:
      return { ...state, isLoggedIn: payload };
    case remoteLogoutAction.TRIGGER:
      return { ...state, isLoggedOut: true };

    case remoteLogoutAction.SUCCESS:
      return { ...state, isLoggedOut: payload };

    case getUserConstants.TRIGGER:
      return { ...state, userConstants: [] };
    case getUserConstants.SUCCESS:
      return { ...state, userConstants: payload };
    case getUserConstants.FAILURE:
      return { ...state, error: payload };

    default:
      return state;
  }
}

export default appReducer;
